import { Component, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'spw-cookies',
  styleUrl: 'spw-cookies.scss',
  shadow: true,
})
export class SpwCookies {
  /** Titre affiché dans la bannière de cookies */
  @Prop() cookiesTitle: string = 'Nous utilisons des cookies';
  /** Description des cookies et de leur utilisation, affichée dans la bannière */
  @Prop() cookiesDescription: string =
    `Ce site web utilise des cookies essentiels pour assurer son bon fonctionnement et des cookies de suivi pour comprendre comment vous interagissez avec lui. Ces derniers ne seront installés qu'après avoir obtenu votre consentement.`;
  /** Texte du bouton pour accepter tous les cookies */
  @Prop() acceptAllButtonText: string = 'Accepter tous les cookies';
  /** Texte du bouton pour accepter uniquement les cookies fonctionnels */
  @Prop() acceptRequiredButtonText: string = 'Accepter uniquement les cookies fonctionnels';

  @State() isVisible: boolean = false;
  @State() analyticsEnabled: boolean = false;

  componentWillLoad() {
    this.initializeCookieSettings();
    this.checkCookieSettings();
  }

  private initializeCookieSettings() {
    if (localStorage.getItem('spw-cookie-settings__required') === null) {
      localStorage.setItem('spw-cookie-settings__required', 'false');
    }
    if (localStorage.getItem('spw-cookie-settings__analytics') === null) {
      localStorage.setItem('spw-cookie-settings__analytics', 'false');
    }
    if (localStorage.getItem('spw-cookie-settings__saved') === null) {
      localStorage.setItem('spw-cookie-settings__saved', 'false');
    }
  }

  private checkCookieSettings() {
    const settings = this.getCookieSettings();
    if (!settings['spw-cookie-settings__saved']) {
      this.isVisible = true;
    }
    this.analyticsEnabled = settings['spw-cookie-settings__analytics'];
  }

  private getCookieSettings() {
    return {
      'spw-cookie-settings__required': JSON.parse(localStorage.getItem('spw-cookie-settings__required')),
      'spw-cookie-settings__analytics': JSON.parse(localStorage.getItem('spw-cookie-settings__analytics')),
      'spw-cookie-settings__saved': JSON.parse(localStorage.getItem('spw-cookie-settings__saved')),
    };
  }

  private setCookieSettings(settings: { [key: string]: boolean }) {
    Object.keys(settings).forEach(key => {
      localStorage.setItem(key, JSON.stringify(settings[key]));
    });
  }

  private toggleAnalytics() {
    this.analyticsEnabled = !this.analyticsEnabled;
    this.setCookieSettings({ 'spw-cookie-settings__analytics': this.analyticsEnabled });
  }

  private acceptAllCookies() {
    this.setCookieSettings({
      'spw-cookie-settings__required': true,
      'spw-cookie-settings__analytics': true,
      'spw-cookie-settings__saved': true,
    });
    this.isVisible = false;
  }

  private acceptRequiredCookies() {
    this.setCookieSettings({
      'spw-cookie-settings__required': true,
      'spw-cookie-settings__analytics': false,
      'spw-cookie-settings__saved': true,
    });
    this.isVisible = false;
  }

  render() {
    if (!this.isVisible) {
      return null;
    }

    return (
      <div class="spw-cookies">
        <div class="spw-cookies__container">
          <div class="spw-cookies__content">
            <h2 class="spw-cookies__title">{this.cookiesTitle}</h2>
            <p class="spw-cookies__text">{this.cookiesDescription}</p>
            <spw-accordion>
              <spw-accordion-item>
                <spw-accordion-title slot="title">Paramétrer les cookies</spw-accordion-title>
                <spw-accordion-content slot="content">
                  <div class="spw-cookies__checkbox">
                    <spw-checkbox checked={this.analyticsEnabled} onSpwChange={() => this.toggleAnalytics()}>
                      <span class="spw-cookies__checkbox-text">
                        Les cookies de statistiques proviennent de sociétés de externes ("cookies tiers") et sont utilisés pour collecter des informations sur les sites web visités
                        par l'utilisateur.
                      </span>
                    </spw-checkbox>
                  </div>
                </spw-accordion-content>
              </spw-accordion-item>
            </spw-accordion>
          </div>
          <div class="spw-cookies__buttons">
            <spw-button is-full-width="true" onClick={() => this.acceptAllCookies()}>
              {this.acceptAllButtonText}
            </spw-button>
            <spw-button is-full-width="true" variant="secondary" onClick={() => this.acceptRequiredCookies()}>
              {this.acceptRequiredButtonText}
            </spw-button>
          </div>
        </div>
      </div>
    );
  }
}
